import { useEffect, useState } from "react";
import { baseUrl } from "../Common/BaseUrl";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { formatDigit } from "./format.util";
import config  from '../../utils/config'

const {imageUrl} = config


const PairList = ({ PairList, firstCoin, secondCoin, favRefresh ,socket }) => {
  const [ActiveTab, set_ActiveTab] = useState("USDT");
  const [TabFilter, set_TabFilter] = useState(["USDT"]);
  const [searchedValue, set_searchedValue] = useState("");
  const [exchangeTab, set_exchangeTab] = useState([]);
  const [order, set_order] = useState(true);
  const [ActivePair, set_ActivePair] = useState("");

  // ✅ Replace exchange/tabs/list API call
  useEffect(() => {
    socket.emit(
      "tab_list", // <-- You must have this event in backend
      {},
      (res) => {        
        if (res?.status) {
          set_exchangeTab(res.data);
        } else {
          toast.error(res?.message || "Failed to load tabs");
        }
      }
    );
  },[firstCoin,secondCoin]);

  // ✅ Update ActivePair on prop change
  useEffect(() => {
    set_ActivePair(`${firstCoin}/${secondCoin}`);
  }, [firstCoin, secondCoin]);

  // ✅ If fav tab, refresh on favRefresh change
  useEffect(() => {
    if (ActiveTab === "fav") {
      fetch_fav_pairs();
    }
  }, [favRefresh]);

  const activeCurrency = (value) => {
    localStorage.setItem("ActiveTab", value);
    set_ActiveTab(value);
    if (value === "fav") {
      fetch_fav_pairs();
    } else {
      set_TabFilter([value]);
    }
  };

  const onSearch = (e) => {
    set_searchedValue(e.target.value);
  };

  const fetch_fav_pairs = () => {
    console.log("this")
    if (!localStorage.getItem("jwtToken")) return;
        console.log("this")
    socket.emit(
      "fav_pairs_action",
      { action: "get" },
      (res) => {

        console.log("favpairs",res)
        if (res?.status) {
          set_TabFilter(res.data); // data is favPairs list
        } else {
          toast.error(res?.message || "Failed to load favorite pairs");
        }
      }
    );
  };

  const coinListHtml = (pairlist) => {
    const filteredItems = pairlist.filter((item) => {
      const itemPairLower = item.pair.toLowerCase();
const activeTabMatch = TabFilter.some((tab) =>
  itemPairLower.endsWith(tab.toLowerCase())
);
      const searchValueMatch = itemPairLower.includes(
        searchedValue.toLowerCase()
      );
      return activeTabMatch && searchValueMatch;
    });

    filteredItems.sort((a, b) => {
      const changeA = parseFloat(a.change_persentage);
      const changeB = parseFloat(b.change_persentage);
      return order ? changeB - changeA : changeA - changeB;
    });

    

    return filteredItems.map((item) => (
      <tr
        key={item.id}
        className={item.pair === ActivePair ? "ng-scope active" : "ng-scope"}
      >
        <Link to={`/exchange/${item.pair}`}>
          <td className="r-market-pair ng-binding fw600">
            {/* {console.log(`${imageUrl}/${item?.pair?.split('/')[0].toLowerCase()}.svg`)} */}
            {1 ? (
              <img
                className="currency_icon"
                // src={baseUrl + "/static/currencyImage/" + item.currency_image}
                src={`${imageUrl}/images/${item?.pair?.split('/')[0].toLowerCase()}.svg`}
                // src={`https://cdn.jsdelivr.net/gh/vadimmalykhin/binance-icons/crypto/${item.pair.split('/')[0].toLowerCase()}.svg`}
                onError={(e)=>e.target.src="https://dummyimage.com/40x40/cccccc/000000.png&text=ven"}
              />
            ) : (
              <img className="currency_icon" src="/assets/img/btc.png" alt="" />
            )}
            {item.pair}
          </td>
          <td className="r-market-price ng-binding fw600">
            <span
              style={{
                color:
                  item.change_persentage < 0  ? "#ff505d" : "#00bc8b",
              }}
            >
              {isNaN(item.current_price)
                ? "0.00"
                : formatDigit(item.current_price)}
            </span>
          </td>
          <td className="r-market-rate ng-scope tr">
            <span
              style={{
                color:
                  item.change_persentage < 0 ? "#ff505d" : "#00bc8b",
              }}
            >
              {isNaN(item.change_persentage)
                ? "0.00"
                : item.change_persentage}
              %
            </span>
          </td>
        </Link>
      </tr>
    ));
  };

  return (
    <div className="order-history-outer ne_box col-non-padding col-min-padding-right">
      <div className="panel panel-default">
        <div className="panel-heading tab-box">
          <ul className="exchange_tab">
            {localStorage.getItem("jwtToken") && (
              <li
                className={
                  ActiveTab === "fav" ? "active tabQuoteAsset" : "tabQuoteAsset"
                }
                onClick={() => activeCurrency("fav")}
              >
                <i className="fa fa-star"></i>
              </li>
            )}
            {exchangeTab.map((list) => (
              <li
                // key={i}
                className={
                  ActiveTab === list.symbol
                    ? "active tabQuoteAsset"
                    : "tabQuoteAsset"
                }
                onClick={() => activeCurrency(list.symbol)}
              >
                {list.symbol}
              </li>
            ))}
          </ul>
          <div className="clearfix"></div>
        </div>
        <div className="panel-body p-0">
          <div className="searchFilter f-cb">
            <div className="search-box search-box-new">
              <input
                type="text"
                id="search-int"
                placeholder=""
                onChange={onSearch}
                value={searchedValue}
              />
            </div>
          </div>
        </div>
        <table className="table mb-0 currency_table1">
          <thead>
            <tr>
              <th className="f-left r-market-pair ng-binding">Pair</th>
              <th className="f-left r-market-price ng-binding">Price</th>
              <th
                className="r-market-rate ng-binding ng-scope tr"
                onClick={() => set_order(!order)}
                style={{ cursor: "pointer" }}
              >
                Change
                <span>
                  {order ? (
                    <i className="fa fa-caret-down"></i>
                  ) : (
                    <i className="fa fa-caret-up"></i>
                  )}
                </span>
              </th>
            </tr>
          </thead>
        </table>
        <div className="table-overflow">
          <table className="table table-hover currency_table">
            {coinListHtml(PairList)}
          </table>
        </div>
      </div>
    </div>
  );
};

export { PairList };
